module.exports = __webpack_public_path__ + "media/images/design/images/pickup_img02-1dc3e19271fc61cbdbd2fb3818347560.jpg";